import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_clincal_overview = _resolveComponent("clincal-overview")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_appointment_queues = _resolveComponent("appointment-queues")!
  const _component_appointment_booking = _resolveComponent("appointment-booking")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, { flat: "" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_tabs, {
        modelValue: _ctx.tab,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tab) = $event)),
        color: "primary",
        centered: "",
        stacked: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_tab, {
            value: "tab-1",
            density: "compact"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Overview ")
            ]),
            _: 1
          }),
          _createVNode(_component_v_tab, {
            value: "tab-2",
            density: "compact"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Queues ")
            ]),
            _: 1
          }),
          _createVNode(_component_v_tab, {
            value: "tab-3",
            density: "compact"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Booking ")
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_v_window, {
        modelValue: _ctx.tab,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.tab) = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_window_item, { value: "tab-1" }, {
            default: _withCtx(() => [
              _createVNode(_component_clincal_overview)
            ]),
            _: 1
          }),
          _createVNode(_component_v_window_item, { value: "tab-2" }, {
            default: _withCtx(() => [
              _createVNode(_component_appointment_queues)
            ]),
            _: 1
          }),
          _createVNode(_component_v_window_item, { value: "tab-3" }, {
            default: _withCtx(() => [
              _createVNode(_component_appointment_booking)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }))
}